import { render, staticRenderFns } from "./widget_portfolio_risk.vue?vue&type=template&id=0f68ef65&scoped=true&"
import script from "./widget_portfolio_risk.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_risk.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_risk.vue?vue&type=style&index=0&id=0f68ef65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68ef65",
  null
  
)

export default component.exports